import React, { Component } from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';

import ThunderYellowImage from '../../images/flashYellow.svg';
import ThunderRedImage from '../../images/flashRed.svg';
import ThunderStopIcon from '../../images/flashYellow2.svg';

class ThunderHitMenu extends Component {

    shouldComponentUpdate(nextProps, nextState) {
        if (!this.compareLists(this.props.thunderStrikesList, nextProps.thunderStrikesList)
            || this.props.simulateThunderStorm !== nextProps.simulateThunderStorm) {
            return true;
        }
        else {
            return false;
        }
    }

    compareLists = (list1, list2) => {
        ////NOTE: deep compare is needed
        if (list1.length !== list2.length) {
            return false;
        }
        return true;
    }

    render() {

        let ohlList = [];
        let ohlAffectedList = [];
        let outageList = this.props.ohlThunderStrikesList.filter(hit => hit.isOutage);

        this.props.ohlThunderStrikesList.forEach(hit => {
            if (!ohlList.includes(hit.ohl)) ohlList = ohlList.concat(hit.ohl)
        });

        outageList.forEach(hit => {
            if (!ohlAffectedList.includes(hit.ohl)) ohlAffectedList = ohlAffectedList.concat(hit.ohl)
        });

        return (
            <span>
                <div style={{ marginBottom: '20px' }}>
                    <span onClick={this.props.toogleSimulateThunderStorm} >
                        <img
                            src={this.props.simulateThunderStorm === true ? ThunderStopIcon : ThunderYellowImage}
                            style={{ marginRight: '20px', width: '20px', height: '20px' }}
                            title={this.props.simulateThunderStorm === true ? 'Stop thunderstorm' : 'Simulate thunderstorm'}
                            alt={this.props.simulateThunderStorm === true ? 'Stop thunderstorm' : 'Simulate thunderstorm'}
                        />
                        {this.props.simulateThunderStorm === true ? 'Stop simulation' : 'Simulate lightning storm'}
                    </span>
                </div>
                <Divider />
                <List>
                    <ListItem><ListItemText primary={'Number of all lightning strikes:  ' + this.props.thunderStrikesList.length} /></ListItem>
                    <ListItem><ListItemText primary={'Number of affecting lightning strikes:  ' + this.props.ohlThunderStrikesList.length} /></ListItem>
                    <ListItem><ListItemText primary={'Number of outages:  ' + outageList.length} /></ListItem>
                    {/* <ListItem><ListItemText primary={'Number of affected OHLS:  ' + ohlList.length} /></ListItem> */}
                    <ListItem><ListItemText primary={'Number of OHLS with outage:  ' + outageList.length} /></ListItem>
                    {/* <ListItem><ListItemText primary={'Number of all thunders:  ' + this.props.numberOfLightnings }/></ListItem> */}
                </List>
                <Divider />
                <List>
                    {this.props.ohlThunderStrikesList.map((hit, index) =>
                        <ListItem key={index}>
                            <ListItemText
                                primary={index + 1 + '. ' + hit.ohl}
                                secondary={'Time: ' + hit.time}
                            />
                            <span style={{ marginLeft: '5px', marginRight: '5px', cursor: 'pointer' }} >
                                <img
                                    src={hit.isOutage ? ThunderRedImage : ThunderYellowImage}
                                    title={hit.isOutage ? 'Show outage' : 'Show OHL hit'}
                                    style={{ width: '20px !important', height: '20px' }}
                                    alt='thunder'
                                    onClick={hit.isOutage ? () => this.props.onOutageHitClick(hit) : () => this.props.onOhlThunderHitClick(hit)} />
                            </span>
                        </ListItem>
                    )}
                </List>
            </span>
        )
    }
}


export default ThunderHitMenu;